import { LAST_TERMS_AND_CONDITIONS_VERSION, } from '@innovyze/stylovyze/lib/types/terms.types';
import { authApi } from '@innovyze/stylovyze/lib/apis';
export const acceptTerms = () => {
    return authApi.post(`/terms-and-conditions/${LAST_TERMS_AND_CONDITIONS_VERSION}`);
};
